<template>
  <div class="flex w-full h-screen rounded-lg shadow-lg">
    <!-- Left Image & Text -->
    <div
        :style="{ backgroundImage: `url(${require('@/assets/img/Malhadinha-Nova-3.webp')})` }"
        class="w-2/4 hidden md:flex flex-col flex-[1.2] bg-cover bg-center bg-no-repeat relative text-primary px-10"
    >
      <div class="mt-20 text-center">
        <h2 class="text-4xl font-bold mb-2">Secure your account</h2>
        <h1 class="text-6xl font-bold">Change Password</h1>
      </div>
    </div>

    <!-- Right Form -->
    <div class="w-2/4 flex flex-col flex-1 justify-center bg-white px-12 text-[#4D2F00] relative">
      <!-- Logo -->
      <div class="flex items-center justify-center mb-10">
        <img
            alt="Bison Mobile Logo"
            class="w-20 h-20 mr-3"
            src="@/assets/img/Bison-bank-logo.png"
        />
        <span class="font-semibold text-3xl text-gray-500">Bison Mobile</span>
      </div>

      <!-- Change Password Form -->
      <form class="flex flex-col" @submit.prevent="handleChangePassword">
        <!-- Current Password -->
        <label class="mb-1 text-sm" for="current">Current Password</label>
        <div class="relative mb-5">
          <input
              v-model="currentPassword"
              :type="showCurrent ? 'text' : 'password'"
              id="current"
              placeholder="Enter current password"
              class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <button
              type="button"
              @click="showCurrent = !showCurrent"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <component :is="showCurrent ? EyeOff : Eye" class="w-5 h-5"/>
          </button>
        </div>

        <!-- New Password -->
        <label class="mb-1 text-sm" for="new">New Password</label>
        <div class="relative mb-5">
          <input
              v-model="newPassword"
              :type="showNew ? 'text' : 'password'"
              id="new"
              placeholder="Enter new password"
              class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <button
              type="button"
              @click="showNew = !showNew"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <component :is="showNew ? EyeOff : Eye" class="w-5 h-5"/>
          </button>
        </div>

        <!-- Confirm Password -->
        <label class="mb-1 text-sm" for="confirm">Confirm New Password</label>
        <div class="relative mb-5">
          <input
              v-model="confirmPassword"
              :type="showConfirm ? 'text' : 'password'"
              id="confirm"
              placeholder="Confirm new password"
              class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <button
              type="button"
              @click="showConfirm = !showConfirm"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <component :is="showConfirm ? EyeOff : Eye" class="w-5 h-5"/>
          </button>
        </div>

        <button
            class="bg-primary text-white font-semibold py-3 rounded-md transition-colors flex justify-center items-center disabled:opacity-50"
            type="submit"
            :disabled="loading"
        >
          <span v-if="!loading">CHANGE PASSWORD</span>
          <svg
              v-else
              class="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
          >
            <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
            ></circle>
            <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
        </button>

        <!-- پیام خطا/موفقیت -->
        <p v-if="errorMessage" class="mt-3 text-red-600 text-sm">
          {{ errorMessage }}
        </p>
        <p v-if="successMessage" class="mt-3 text-green-600 text-sm">
          {{ successMessage }}
        </p>
      </form>

      <!-- Footer -->
      <div class="flex flex-col items-center mt-10 text-sm text-[#4D2F00]">
        <component :is="LockKeyhole" />
        Always use your Homebanking with safety
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { LockKeyhole, Eye, EyeOff } from "lucide-vue-next";
import api from "@/services/api";
// import { useRouter } from "vue-router";

const currentPassword = ref("");
const newPassword = ref("");
const confirmPassword = ref("");
const loading = ref(false);

const errorMessage = ref("");
const successMessage = ref("");

// state برای چشم‌ها
const showCurrent = ref(false);
const showNew = ref(false);
const showConfirm = ref(false);
// const forcePasswordChange = ref(localStorage.getItem('force_password_change') === '1')

// const router = useRouter();

async function handleChangePassword() {
  errorMessage.value = "";
  successMessage.value = "";

  if (newPassword.value !== confirmPassword.value) {
    errorMessage.value = "Passwords do not match!";
    return;
  }

  try {
    loading.value = true;
    const token = localStorage.getItem('token')
    await api.post("/change-password", {
      current_password: currentPassword.value,
      new_password: newPassword.value,
      confirm_password: confirmPassword.value,
    },{
      headers: { Authorization: `Bearer ${token}` },
    });
    localStorage.setItem('force_password_change', '0')
    // forcePasswordChange.value = false
    successMessage.value = "Password updated successfully!";
    // router.push("/");
    // بعد از چند ثانیه می‌فرستیمش به داشبورد
    setTimeout(() => {
      window.location.reload()
    }, 1500);
  } catch (err) {
    errorMessage.value =
        err.response?.data?.message || "Failed to change password";
  } finally {
    loading.value = false;
  }
}
</script>
